import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Button } from '@/components';

type ZeroCostConfirmationDialogProps = {
  visible: boolean;
  onAccept: () => void;
  onCancel: () => void;
  fechaRetiro?: string;
  initialFechaRetiro?: string;
};

const ZeroCostConfirmationDialog: FC<ZeroCostConfirmationDialogProps> = ({
  visible,
  onAccept,
  onCancel,
  fechaRetiro,
  initialFechaRetiro,
}) => {
  const { t } = useTranslation('importFCL');

  const dialogHeader = (
    <div className="text-blue-800">{t('changeDateConfirmation')}</div>
  );

  const footerContent = (
    <div className="w-full flex justify-content-end gap-2">
      <Button
        label={t('cancel')}
        onClick={onCancel}
        style={{ color: '#170a33', width: '100px' }}
        outlined
      />
      <Button
        label={t('accept')}
        onClick={onAccept}
        style={{ backgroundColor: '#007ad9', color: '#FFFFFF', width: '100px' }}
      />
    </div>
  );

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      onHide={onCancel}
      footer={footerContent}
      modal
      style={{ width: '500px' }}
    >
      <div className="p-4">
        <p>
          {t('deliveryScheduledFor')} {initialFechaRetiro},{' '}
          {t('wantToRescheduleDelivery')} {fechaRetiro}{' '}
          {t('andRetireWithSameDeliveryOrder')}
        </p>
      </div>
    </Dialog>
  );
};

export default ZeroCostConfirmationDialog;
